// services/grupos/index.js
import api from "services/api";

const ENDPOINT = "/group";

const unwrapList = (data) =>
  Array.isArray(data)
    ? data
    : Array.isArray(data?.page)
    ? data.page
    : Array.isArray(data?.data)
    ? data.data
    : Array.isArray(data?.results)
    ? data.results
    : [];

const normalizeListResponse = (data) => {
  const rows = unwrapList(data);

  return {
    rows,
    total: Number(data?.total ?? data?.count ?? data?.totalRows ?? rows.length ?? 0),
    limit: data?.limit,
    offset: data?.offset,
    raw: data,
  };
};

const toFormData = (obj = {}) => {
  const fd = new FormData();

  Object.entries(obj).forEach(([k, v]) => {
    if (v === undefined || v === null) return;

    if (Array.isArray(v)) {
      v.forEach((it) => fd.append(k, it));
    } else {
      fd.append(k, v);
    }
  });

  return fd;
};

const hasBinary = (obj = {}) =>
  Object.values(obj).some(
    (v) =>
      (typeof File !== "undefined" && v instanceof File) ||
      (typeof Blob !== "undefined" && v instanceof Blob)
  );

/**
 * Lista grupos con soporte para:
 * - paginación: __limit, __offset
 * - ordenamiento: __sort
 * - búsqueda: name[$contains]
 *
 * Devuelve siempre:
 * {
 *   rows: [],
 *   total: number,
 *   limit,
 *   offset,
 *   raw
 * }
 */
export async function listGrupos(params = {}) {
  const { data } = await api.get(ENDPOINT, { params });
  return normalizeListResponse(data);
}

export async function getGrupoById(id) {
  const { data } = await api.get(`${ENDPOINT}/${encodeURIComponent(id)}`);
  return data?.data ?? data ?? {};
}

export async function createGrupo(payload) {
  const body = payload instanceof FormData ? payload : toFormData(payload);

  const { data } = await api.post(ENDPOINT, body, {
    headers: { "Content-Type": undefined },
    transformRequest: [
      (data, headers) => {
        if (headers) {
          delete headers.post?.["Content-Type"];
          delete headers.put?.["Content-Type"];
          delete headers.common?.["Content-Type"];
        }
        return data;
      },
    ],
  });

  return data?.data ?? data;
}

export async function updateGrupo(id, payload, method = "PUT") {
  const url = `${ENDPOINT}/${encodeURIComponent(id)}`;

  if (payload instanceof FormData) {
    const { data } = await api.put(url, payload, {
      headers: { "Content-Type": undefined },
      transformRequest: [
        (data, headers) => {
          if (headers) {
            delete headers.post?.["Content-Type"];
            delete headers.put?.["Content-Type"];
            delete headers.common?.["Content-Type"];
          }
          return data;
        },
      ],
    });

    return data?.data ?? data;
  }

  if (hasBinary(payload)) {
    const fd = toFormData(payload);

    const { data } = await api.put(url, fd, {
      headers: { "Content-Type": undefined },
      transformRequest: [
        (data, headers) => {
          if (headers) {
            delete headers.post?.["Content-Type"];
            delete headers.put?.["Content-Type"];
            delete headers.common?.["Content-Type"];
          }
          return data;
        },
      ],
    });

    return data?.data ?? data;
  }

  const { data } = await api.put(url, payload, {
    headers: { "Content-Type": "application/json" },
  });

  return data?.data ?? data;
}

export async function deleteGrupo(id) {
  const { data } = await api.delete(`${ENDPOINT}/${encodeURIComponent(id)}`);
  return data?.data ?? data;
}